module.exports = __webpack_public_path__ + "img/bunkering-log-active.5f14cfb9.svg";